import {
  Component, ComponentFactoryResolver, ChangeDetectorRef, OnInit, EventEmitter,
  ViewContainerRef, ViewChild, OnDestroy, AfterViewInit
} from "@angular/core";
import {UserWizardService} from "../../../services/user/user.wizard.service";
import {ActivatedRoute} from "@angular/router";
import {UsersSubContentComponent} from "./users.sub.content.component";
import {UsersRolesComponent} from "./users.roles.component";
import {UsersGroupComponent} from "./users.group.component";
import {UserService} from "@nrwl/common-lib";
import {WizardComponent} from "../../../wizard.component";
import {Subscription} from "rxjs";
import { get, merge } from 'lodash';
import {IWizardEntry} from "../../../wizard.entry";
import { AddUserGroupService } from "./add.user.group.service";
import { NewUserGroupResultComponent } from "./new.user.group.result/new.user.group.result.component";

@Component({
  selector: "new-user-group-wizard",
  providers: [UserWizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../../../wizard.button.style.scss"]
})
export class NewUserGroupWizardComponent extends WizardComponent implements OnInit, AfterViewInit, OnDestroy, IWizardEntry{
  wizardConfig: any;
  wizardId: string;
  dataId: any;
  onClose = new EventEmitter<any>();

  wizardService: AddUserGroupService;
  userService: UserService;
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;

  @ViewChild("contentPlaceholder", { read: ViewContainerRef,
static: true })
  contentRef: ViewContainerRef;
  @ViewChild("subContentPlaceholder", { read: ViewContainerRef,
static: true })
  subContentRef: ViewContainerRef;

  constructor(
    wizardService: AddUserGroupService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((data) => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', "{}")));

      this.wizardService.editMode = true;

      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
      this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    const result = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent()
    });    
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    } else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
    return this.subContentRef;
  }

  resolveComponentType(pageId: any) {
    switch (pageId) {
      case 'users.group.html':
        return UsersGroupComponent;
      case 'users.sub.content.html':
        return UsersSubContentComponent;
      case 'users.roles.html':
        return UsersRolesComponent;
      case 'new.user.group.result.component.html':
        return NewUserGroupResultComponent;  
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
}
